import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { articles } from "@/data/articles";

export default function GuidesSection() {
  const { t } = useTranslation();

  return (
    <section id="guides" className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="text-2xl font-bold text-foreground-950 md:text-4xl">{t("guides.title")}</h2>
          <p className="mt-3 text-base text-foreground-600">{t("guides.subtitle")}</p>
        </div>

        <div className="mx-auto mt-10 max-w-3xl">
          <Link
            to="/usfans-spreadsheet-guide"
            className="group flex cursor-pointer flex-col gap-4 rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 sm:flex-row sm:items-center md:p-6"
          >
            <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
              <i className="ri-book-read-line text-2xl" />
            </span>
            <div className="flex-1">
              <span className="inline-block whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-semibold text-secondary-800">
                {t("guides.article.tag")}
              </span>
              <h3 className="mt-2 font-heading text-lg font-semibold text-foreground-950 md:text-xl">{t("guides.article.title")}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{t("guides.article.excerpt")}</p>
            </div>
            <span className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors group-hover:bg-primary-600">
              {t("guides.readMore")}
              <i className="ri-arrow-right-line text-sm" />
            </span>
          </Link>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {articles.map((a) => (
            <Link
              key={a.slug}
              to={`/articles/${a.slug}`}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
            >
              <div className="aspect-[16/9] w-full overflow-hidden">
                <img
                  src={a.image}
                  alt={t(`articles.list.${a.slug}.title`)}
                  className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                />
              </div>
              <div className="flex flex-1 flex-col p-5">
                <span className="inline-block self-start whitespace-nowrap rounded-full bg-accent-100 px-2.5 py-1 text-xs font-semibold text-accent-800">
                  {t(`articles.list.${a.slug}.tag`)}
                </span>
                <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950">{t(`articles.list.${a.slug}.title`)}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{t(`articles.list.${a.slug}.excerpt`)}</p>
                <span className="mt-4 inline-flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-primary-700 transition-colors group-hover:text-primary-600">
                  {t("guides.readMore")}
                  <i className="ri-arrow-right-line text-sm" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}